import React from "react";
import logo from "@assets/images/Corvell.jpg";
import { CloseIcon, DashboardIcon } from "@assets/svgIcons";
import { sidebarItems, LogoutIcon } from "./sidebarData";
import "./index.scss";

const Sidebar = ({
  isOpen,
  onClose,
  activeTab,
  onTabChange,
  onLogout,
  isCollapsed,
  onToggleCollapse,
}) => {
  return (
    <>
      {/* Mobile Overlay */}
      {isOpen && <div className="sidebar-overlay" onClick={onClose} />}

      {/* Sidebar */}
      <div
        className={`sidebar ${isOpen ? "open" : ""} ${
          isCollapsed ? "collapsed" : ""
        }`}
      >
        <div className="sidebar-header">
          <div className="sidebar-logo-container">
            {!isCollapsed && (
              <img src={logo} alt="Logo" className="sidebar-logo" />
            )}
            {isCollapsed && (
              <div className="sidebar-collapsed-logo">
                <DashboardIcon />
              </div>
            )}
          </div>
          <button className="close-sidebar-btn" onClick={onClose}>
            <CloseIcon />
          </button>
        </div>

        <nav className="sidebar-nav">
          {sidebarItems.map((item) => (
            <button
              key={item.id}
              className={`sidebar-item ${
                activeTab === item.id ? "active" : ""
              }`}
              onClick={() => {
                onTabChange(item.id);
                onClose();
              }}
              title={isCollapsed ? item.label : ""}
            >
              <div className="sidebar-icon-container">
                <item.icon />
              </div>
              <span className="sidebar-label">{item.label}</span>
            </button>
          ))}
        </nav>

        <div className="sidebar-footer">
          <button
            className="logout-btn"
            onClick={onLogout}
            title={isCollapsed ? "Logout" : ""}
          >
            <div className="sidebar-icon-container">
              <LogoutIcon />
            </div>
            <span className="sidebar-label">Logout</span>
          </button>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
